module.exports = __webpack_public_path__ + "img/erma.0ae65372.png";